import request from '@/utils/request'

// 查询大乐透列表
export function listDlt(query) {
    return request({
        url: '/admin/lottery/dlt/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期大乐透数据
export function latestDlt() {
    return request({
        url: '/admin/lottery/dlt/latest',
        method: 'get',
    })
}

// 初始化大乐透数据
export function initAllDlt() {
    return request({
        url: '/admin/lottery/dlt/initAll',
        method: 'post'
    })
}

// 补全大乐透历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/dlt/fillHistoryData',
        method: 'post'
    })
}

// 获取大乐透号码出现次数
export function getDltNumData() {
    return request({
        url: '/admin/lottery/dlt/getNumData',
        method: 'get',
    })
}

// 初始化大乐透统计数据
export function initAllDltC() {
    return request({
        url: '/admin/lottery/dlt/initAllC',
        method: 'post'
    })
}

// 刷新大乐透缓存
export function refreshDltCache() {
    return request({
        url: '/admin/lottery/dlt/refreshCache',
        method: 'delete',
    })
}

// 生成大乐透
export function generateDlt(data) {
    return request({
        url: '/admin/lottery/dlt/generate',
        method: 'post',
        data:data
    })
}

// 查询大乐透中奖数据
export function getDltWinningData(query){
    return request({
        url: '/admin/lottery/dlt/getWinningData',
        method: 'get',
        params: query
    })
}
// 查询大乐透历史同期中奖数据
export function getNextDltHistory(period){
    return request({
        url: '/admin/lottery/dlt/getNextHistory?period='+period,
        method: 'get'
    })
}

// 查询大乐透下期数字频率
export function getNextNumFrequency(query){
    return request({
        url: '/admin/lottery/dlt/getNextNumFrequency',
        method: 'get',
        params: query
    })
}
